import { GDriveFileResponse } from './types'
import { PresentationFileOwners } from '../presentation_files/PresentationFileOwners'
import { Box, Button } from '@mui/material'
import { openTab } from '../Helpers'
import React from 'react'

export function GDriveFilesResponse({
  filesResponse,
}: {
  filesResponse: GDriveFileResponse
}) {
  const {
    data: {
      data,
      errors: [error],
    },
    meta: { folder_id },
  } = filesResponse

  if (error) {
    return (
      <Box padding="10px">
        <Box>
          <strong>ERROR:</strong>
        </Box>
        <Box padding="5px">{`${(error as any).type}: ${(error as any).value}`}</Box>
      </Box>
    )
  }

  const folderUrl = `https://drive.google.com/drive/folders/${folder_id}`
  return (
    <Box>
      <Box padding="5px">
        GDrive Folder:
        <Button onClick={() => openTab(folderUrl)}>Open</Button>
      </Box>
      <PresentationFileOwners presentationFiles={data.files} />
      <PresentationFileErrors errors={data.errors} />
    </Box>
  )
}

function PresentationFileErrors({
  errors,
}: {
  errors: { file_id: string; error: string }[]
}) {
  if (!errors.length) return null
  return (
    <Box>
      <Box padding="5px">
        <strong>ERRORS:</strong>
      </Box>
      <Box padding="5px">
        {errors.map(({ file_id, error }) => {
          return <Box key={file_id}>{`${file_id}: ${error}`}</Box>
        })}
      </Box>
    </Box>
  )
}
